import { render, staticRenderFns } from "./Connection.vue?vue&type=template&id=64cd12b2&"
import script from "./Connection.vue?vue&type=script&lang=ts&"
export * from "./Connection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports